<template>
    <div v-bind:class="[{ busy: loadingSampleCollection }]" class="article-dropdown-container opacity-transition">
        <pb-spinner v-if="loadingSampleCollection"></pb-spinner>
        <div v-else-if="sampleCount > 0 && !loadingSampleCollection">
            <div class="inner">
                <article-preview :key="sample.id" v-for="(sample) in sampleItemList"
                                 :thumbnail="sample.articleVariant.thumbnail"
                                 :article-details="sample.articleDetails">
                </article-preview>
            </div>
            <b-container>
                <b-row>
                    <b-col>
                        <b-button :to="{ name: 'sample-overview'}"
                                  @click.stop="$emit('navigate')"
                                  class="btn-block my-2">GO TO OVERVIEW
                        </b-button>
                        <b-button :to="{ name: 'sample-checkout'}"
                                  @click.stop="$emit('navigate')"
                                  variant="primary"
                                  class="btn-block my-2">ORDER SAMPLES
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div v-else class="py-3 text-center">
            No pending sample requests
        </div>
    </div>
</template>
<script>

    import {mapGetters, mapState} from "vuex";
    import ArticlePreview from "../../../../../components/dropdown-nav/ArticlePreview";

    export default {
        name: 'sample-dropdown',
        components: {
            'article-preview': ArticlePreview
        },
        computed: {
            ...mapState('sample', ['loadingSampleCollection']),
            ...mapGetters('sample', ['sampleCount', 'sampleItemList']),
        }
    }
</script>